import type { MonthAtGlanceDTO } from "../models/monthAtGlanceDto";
import type { MonthAtGlanceEntity } from "../../domain/entities/MonthAtGlanceEntity";

export function monthAtGlanceDtoToEntity(dto: MonthAtGlanceDTO): MonthAtGlanceEntity {
  return {
    monthLabel: dto.monthLabel ?? "",
    booksClosed: dto.booksClosed ?? false,
    noClosedMonth: dto.noClosedMonth ?? false,
    asOfBooksClosedLabel: dto.asOfBooksClosedLabel ?? null,
    message: dto.message ?? null,
    plSummary: {
      revenue: Number(dto.plSummary?.revenue) || 0,
      expense: Number(dto.plSummary?.expense) || 0,
      ebitda: Number(dto.plSummary?.ebitda) || 0,
      totalAmount: (Number(dto.plSummary?.totalAmount) ?? Number(dto.plSummary?.revenue)) || 0,
      changePercent: dto.plSummary?.changePercent ?? null,
      changeLabel: dto.plSummary?.changeLabel ?? "Compare from last month",
    },
  };
}
